declare var window: any;

const ScrollLock = {
  mounted(this: any) {
    const handleScrollLock = ({ lock }: any) => {
      var event = new CustomEvent("scroll-lock", { detail: lock });
      window.dispatchEvent(event);
    };
    this.handleEvent("toggle_scroll_lock", handleScrollLock);
  },
};

export default ScrollLock;
